import { motion } from 'framer-motion';
import styled from 'styled-components';

import {
    CommonAction,
    floorGameDuration as duration,
    floorGameEasing as easing,
    recipesCommonAction,
    styledMedia,
} from '@pkg/primitives';

import { type FieldTextProps } from '../FieldText';
import { tokens as fieldTextTokens } from '../FieldText/FieldText.tokens';

import { suffixTransition, SuffixVariant, suffixVariants } from './FieldPassword.motion';

import { tokens } from './FieldPassword.tokens';

interface ShowHideWrapperProps {
    $show?: boolean;
    $size?: FieldTextProps['size'];
    $theme?: FieldTextProps['theme'];
}

export const ShowHideWrapper = styled(motion.div).attrs({
    variants: suffixVariants,
    initial: SuffixVariant.Hidden,
    animate: SuffixVariant.Show,
    exit: SuffixVariant.Hidden,
    transition: suffixTransition,
})<ShowHideWrapperProps>`
    --action-size: ${({ $size = 'medium' }) => tokens.suffixAction[$size]}px;
    --icon-size: ${({ $size = 'medium' }) => tokens.suffixIcon[$size]}px;
    --icon-color: ${({ $theme }) => ($theme === 'light' ? 'black' : 'white')};
    --icon-opacity: ${({ $show }) => ($show ? 0.6 : 0.4)};

    margin-right: ${({ $size = 'medium' }) => fieldTextTokens.gap[$size]}px;
`;

export const ShowHideAction = styled(CommonAction)`
    ${recipesCommonAction.basic};
    width: var(--action-size);
    height: var(--action-size);

    &:hover {
        background-color: rgb(255, 255, 255, 0.1);
    }

    &:active {
        background-color: rgb(255, 255, 255, 0.06);
    }
`;

export const EyeIconWrapper = styled.div`
    ${styledMedia.iconWrapper};
    width: var(--icon-size);
    height: var(--icon-size);
    color: var(--icon-color);
    opacity: var(--icon-opacity);
    transition: opacity ${duration.normal}ms ${easing.cubic};
`;
